var map = {
	"./png/avi.png": "7d86",
	"./png/doc.png": "5e64",
	"./png/excel.png": "ce16",
	"./png/file.png": "b258",
	"./png/html.png": "210e",
	"./png/js.png": "c116",
	"./png/json.png": "5768",
	"./png/md.png": "1819",
	"./png/mp3.png": "555d",
	"./png/mp4.png": "6948",
	"./png/msg.png": "09c2",
	"./png/pdf.png": "7081",
	"./png/picture.png": "1828",
	"./png/powerpoint.png": "318c",
	"./png/shell.png": "d05d",
	"./png/txt.png": "a94d",
	"./png/word.png": "bc96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d70";